export var filterLeagues = function (leagues, sportId) {
    return leagues.filter(function (league) { return league.sportId === sportId; });
};
//# sourceMappingURL=filterLeagues.js.map